import React, { useState, useEffect, useRef, memo } from 'react';

const ExamTimer = memo(({ targetEndTime, onTimeUp }) => {
    const [displayTime, setDisplayTime] = useState(null);

    const callback = useRef(onTimeUp);
    const expiredTarget = useRef(null);
    callback.current = onTimeUp;
    useEffect(() => {
        if (!Number.isFinite(targetEndTime) || targetEndTime <= 0) { setDisplayTime(null); return; }
        // An expired saved session needs explicit recovery in ExamTaker, never a submission on mount.
        const initialNow = Date.now();
        const monotonicStart = performance.now();
        const armed = targetEndTime > initialNow;

        const updateTimer = () => {
            const now = initialNow + Math.max(0, performance.now() - monotonicStart);
            const secondsRemaining = Math.ceil((targetEndTime - now) / 1000);

            if (secondsRemaining <= 0) {
                setDisplayTime(0);
                if (armed && expiredTarget.current !== targetEndTime) {
                    expiredTarget.current = targetEndTime;
                    callback.current?.();
                }
            } else {
                setDisplayTime(secondsRemaining);
            }
        };

        // Initial call
        updateTimer();

        // Interval
        const timerId = setInterval(updateTimer, 1000);
        return () => clearInterval(timerId);
    }, [targetEndTime]);

    const formatTime = (seconds) => {
        if (seconds === null) return '...';
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    };

    return (
        <div className={`text-lg font-mono font-bold px-3 py-1 rounded border bg-white shadow-sm ${displayTime !== null && displayTime < 300 ? 'text-red-600 border-red-200 pulse-red' : 'text-gray-700 border-gray-200'}`}>
            {formatTime(displayTime)}
        </div>
    );
});

export default ExamTimer;